import React from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useTheme } from '@mui/material';

import ViewCalendar from 'app/main/components/page-layouts/view/calendar/ViewCalendar';
import { today } from 'app/main/components/Utils';

import { showInvoicesModuleEditDialog } from '../components/InvoicesModuleEditDialog';

export default function InvoicesDeadlinesCalendarTab() {
	const dispatch = useDispatch();
	const theme = useTheme();

	const [refresh, setRefresh] = React.useState(false);
	const updateRefresh = () => setRefresh(state => !state);

	const dToday = today();

	const getEventColor = (model): string => {
		const deadlineDate = moment(model.indl_d_deadline).utc();
		if (model.indl_force_close) return theme.palette.warning.main;
		if (model.indl_closed === 1) return theme.palette.primary.dark;
		if (deadlineDate.diff(dToday, 'day') <= 0 && model.indl_closed !== 1) return theme.palette.error.main;
		return theme.palette.primary.light;
	};

	const getTitle = (model: any) => {
		return `${model.invc_title} - ${model.comp_title} - ${model.invc_amount_tax_incl?.toFixed(2)}€`;
	};

	const handleClick = ({ model }) => {
		dispatch(showInvoicesModuleEditDialog({ invoiceUid: model.indl_invc_uid, updateRefresh }));
	};

	return (
		<ViewCalendar
			module="invoices_deadlines"
			itemModel={{
				id: 'indl_uid',
				title: getTitle,
				start: 'indl_d_deadline',
				end: 'indl_d_deadline',
				color: getEventColor
			}}
			handleEventClick={handleClick}
			refresh={refresh}
			updateRefresh={updateRefresh}
		/>
	);
}
